import type { Messages } from './messages';

/**
 * Copy for `src/app/tenant/audit/`. Owned by that page's author, and by nobody else.
 *
 * Every key starts with `tenantAudit.` — the compiler refuses anything else, so
 * this file cannot collide with another page's. Shared words (save, cancel,
 * retry, statuses, role names) are already in `common.ts` and
 * `vocabulary.ts`; use those rather than restating them here.
 *
 * The filter bar, table, drawer and integrity card are the shared trail
 * component's, and their copy is `audit.*`. Only what differs is here.
 */
export const tenantAudit = {
  'tenantAudit.title': 'التدقيق',
  'tenantAudit.caption': 'سجل تدقيق المنشأة',
  'tenantAudit.intro': 'ما فعله أعضاء هذه المنشأة، الأحدث أولًا. ما فعله مشغّلو المنصّة داخلها مسجّل في',
  'tenantAudit.operatorTrail': 'سجل التدقيق العام',
  'tenantAudit.emailNotice': 'يعرض هذا السجل بريد أعضاء المنشأة، ويراه كل من يحمل صلاحية قراءة التدقيق، ومنهم الدعم الفني.',
  'tenantAudit.actorHeader': 'العضو',
  'tenantAudit.actorSearch': 'بريد العضو',
  'tenantAudit.noActor': 'بلا عضو — عملية آلية أو دخول لم يُنسب لحساب',
  'tenantAudit.emptyBody': 'لم يُسجَّل في هذه المنشأة أي فعل بعد.',
} as const satisfies Messages<'tenantAudit'>;
